import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c3e44bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "body pt-3" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "mt-4 mw-700" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: "opModal",
    role: "dialog",
    "aria-labelledby": _ctx.name + '_dialog_title'
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Aggiungi familiare",
        text: "Aggiungi familiare",
        id: _ctx.name + '_dialog_title'
      }, null, 8, ["id"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        class: "d-block mb-3",
        localizedKey: "Inserisci l'email del familiare che vuoi invitare",
        text: "Inserisci l'email del familiare che vuoi invitare"
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", {
          for: _ctx.name + '_email'
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Email",
            text: "Email"
          })
        ], 8, _hoisted_5),
        _withDirectives(_createElementVNode("input", {
          id: _ctx.name + '_email',
          ref: "emailInput",
          type: "email",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
        }, null, 40, _hoisted_6), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          role: "button",
          type: "button",
          class: "btn btn-block btn-primary noShadow",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          disabled: _ctx.disabled
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Invia invito",
            text: "Invia invito"
          })
        ], 8, _hoisted_8),
        _createElementVNode("button", {
          role: "button",
          type: "button",
          class: "btn btn-block btn-primary btn-white mt-3",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Annulla",
            text: "Annulla"
          })
        ])
      ])
    ])
  ], 8, _hoisted_1))
}